// extracted by mini-css-extract-plugin
export default {"OptionsHeading":"single-select-options-module__OptionsHeading--_zOXH","SingleSelectForm":"single-select-options-module__SingleSelectForm--jOWJ9"};